import Accordion from '../stories/components/accordion-tabs/accordion-tabs.init';
import CardDeck from '../stories/components/card-deck/card-deck.init';
import ContentFilter from '../stories/components/content-filter/content-filter.init';
import CookieConsent from '../stories/components/cookie-consent/cookie-consent.init';
import Details from '../stories/blocks/details/details.init';
import Dialog from '../stories/components/dialog/dialog.init';
import FindAProvider from '../stories/components/find-a-provider/find-a-provider.init';
import GlobalAlert from '../stories/components/global-alert/global-alert.init';
import GlobalAlerts from '../stories/layouts/global-alerts/global-alerts.init';
import GlobalHeader from '../stories/components/global-header/global-header.init';
import InPageNav from '../stories/components/in-page-nav/in-page-nav.init';
import MenuToggle from '../stories/blocks/menu-toggle/menu-toggle.init';
import NavItem from '../stories/blocks/nav-item/nav-item.init';
import Openstreetmap from '../stories/components/openstreetmap/openstreetmap.init';
import Select from '../stories/blocks/select/select.init';
import Splide from '../stories/layouts/carousel/splide.init';
import VideoLibrary from '../stories/layouts/video-library/video-library.init';

import domReady from './lib/domReady';
import initModule from './lib/initModule';
import addIeBodyClass from './lib/detectIE11';

// Intialize scripts here requiring DOM access.
//
// Any modules imported here should export a function
// that takes a node as its only parameter.
// Import the module then initialize it below inside
// domScripts(), calling initModule() and passing in
// the function and a selector that aligns with the element
// you want to pass into the module.
// initModule() calls the method on each instance
// of the selector passed, so your script can assume
// it is working on a unique DOM node.
//
// example:
// import coolThing from '../ui/blocks/CoolThing/cool-thing.init';
// initModule(coolThing, '.cool-thing');

const domScripts = () => {
  initModule(Accordion, '.accordion-tabs');
  initModule(addIeBodyClass, 'body');
  initModule(CardDeck, '.card-deck');
  initModule(ContentFilter, '.content-filter');
  initModule(CookieConsent, '.cookie-consent');
  initModule(Details, '.details');
  initModule(Dialog, '.dialog');
  initModule(FindAProvider, '.find-a-provider');
  initModule(GlobalAlert, '.global-alert');
  initModule(GlobalAlerts, '.global-alerts');
  initModule(InPageNav, '.in-page-nav');
  initModule(MenuToggle, '.menu-toggle');
  initModule(Openstreetmap, '.openstreetmap');
  initModule(NavItem, 'button.nav-item');
  initModule(GlobalHeader, '.global-header');
  initModule(Select, '.select');
  initModule(Splide, '.splide-container');
  initModule(VideoLibrary, '.video-library');
};

// domReady ensures our scripts fire inside Storybook
// even when navigating component to component,
// calling the passed function on DOMContentLoaded
// and each time the page changes, using MutationObserver
domReady(domScripts);
